import React, { useState } from "react";
import "./Navbar.css";

export default function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const closeMenu = () => setIsMenuOpen(false);

    return (
        <nav className="navbar">
            <a className="navbar-brand" href="#home" onClick={closeMenu}>
                Gramlich Software Services
            </a>
            <button
                className={`hamburger ${isMenuOpen ? "active" : ""}`}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle menu"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div className={`nav-wrapper ${isMenuOpen ? "open" : ""}`}>
                <ul className="navbar-links">
                    <li>
                        <a className="nav-link" href="#services" onClick={closeMenu}>
                            Services
                        </a>
                    </li>
                    <li>
                        <a className="nav-link" href="#reception" onClick={closeMenu}>
                            AI Receptionist
                        </a>
                    </li>
                    <li>
                        <a className="nav-link" href="#process" onClick={closeMenu}>
                            How We Help
                        </a>
                    </li>
                    <li>
                        <a className="nav-link" href="#clients" onClick={closeMenu}>
                            Our Clients
                        </a>
                    </li>
                    <li>
                        <a className="nav-link" href="#about" onClick={closeMenu}>
                            About Riley
                        </a>
                    </li>
                    <li>
                        <a className="nav-link" href="#contact" onClick={closeMenu}>
                            Contact
                        </a>
                    </li>
                </ul>
                <a
                    className="nav-cta"
                    href="https://calendar.app.google/YtNYViW1QVB9m5Xv6"
                    target="_blank"
                    rel="noreferrer"
                    onClick={closeMenu}
                >
                    Book a Consultation
                </a>
            </div>
        </nav>
    );
}
